export const LOAD = 'LOAD';
export const WIDGETS_LOAD = 'WIDGETS_LOAD';
export const WIDGET_CMP_LOADED = 'WIDGET_CMP_LOADED';
export const WIDGET_JSPROP_CHANGE = 'WIDGET_JSPROP_CHANGE';
export const WIDGET_SELECTED = 'WIDGET_SELECTED';
export const WIDGET_JSPROP_UPDATE_FILELD = 'WIDGET_JSPROP_UPDATE_FILELD';
export const EDITOR_RESET_WIDGET = 'EDITOR_RESET_WIDGET';
export const EDITOR_TEMPLATE_CHANGE = 'EDITOR_TEMPLATE_CHANGE';
export const EDITOR_TAB_OPEN = 'EDITOR_TAB_OPEN';
export const EDITOR_ZOOM = 'EDITOR_ZOOM';
export const EDITOR_AUTO_ZOOM = 'EDITOR_AUTO_ZOOM';
export const EDITOR_SET_TEMPLATE = 'EDITOR_SET_TEMPLATE';
export const EDITOR_SET_PREVIEW_STATUS = 'EDITOR_SET_PREVIEW_STATUS';
export const WIDGET_FAV = 'WIDGET_FAV';

export const EDITOR = {
    TABS: {
        LAYOUT: 'layout',
        PARAMS: 'data',
        IMAGE_MANIPULATIONS: 'im',
    },
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/constants.js
 **/